import { DetailList } from 'components/site/modals/DetailListModal/DetailList';
import { ModalWrapperMini } from 'components/site/modals/ModalWrapperMini';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';

export const StoryListModalMini = (): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    const onClose = () => {
        ctxModal.setShowListOfStories(false);
    };

    return (
        <ModalWrapperMini
            onClose={onClose}
            content={<DetailList storyIds={ctxModal.storyList?.visibleStoryIds ?? []} />}
        />
    );
};
